/*
 *
 * RodOption actions
 *
 */

import { action } from 'typesafe-actions';

import ActionTypes from './constants';

export const removeRodsAction = () => action(ActionTypes.REMOVE_RODS);
export const addRodsAction = () => action(ActionTypes.ADD_RODS);
